export default "__VITE_ASSET__CpAOfUXH__"